import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cedula',
  templateUrl: './cedula.component.html',
  styleUrls: ['./cedula.component.css']
})
export class CedulaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
